import React, { Component } from "react";
import { Container, Row, Col, Image, Collapse, Alert } from 'react-bootstrap';
// import CheckIcon from '@material-ui/icons/Check';
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import { Button } from '@material-ui/core';
// import { Events, scrollSpy, scroller } from 'react-scroll';

import { colorPens } from './utils/colors';


class NotFound extends Component {
    constructor(props) {
        super(props);

    }

    render() {
        return (
            <Container fluid>
                <Row className="justify-content-center">
                    <Col onClick={() => { window.location.href = '/'; }}>
                        <div align="center" style={{ fontSize: '3em' }}><b>BeadMeer</b></div>
                        <div align="center" style={{ fontSize: '1em' }}>One-stop Jewellery Pattern Search</div>
                    </Col>
                </Row>
                <br />
                <Row className="justify-content-center align-items-center">
                    <Col md={6}>
                        <Alert variant="danger">
                            <h1 align="center"><b>404 - Not Found</b></h1>
                        </Alert>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default NotFound;